import mondraker from "./mondrakerhome.jpg"
import kryptonite from "./kryptonitehome.jpg"
import mucoff from "./mucoffhomefnl.jpg"
import odi from "./odihome.jpg"

const slider = [
  {
    id: 1,
    image: mondraker,
    title: "MONDRAKER - The Way Forward",
    description:
      "Kontrola. Stabilnost. Potpuna sloboda. Spoj revolucionarne tehnologije, inovativnog dizajna i apsolutne preciznosti pretvorit će svaki teren u tvoj playground.",
    description1: "",
    href: "./bicikli/brand/mondraker/",
    button: "Mondraker",
  },
  {
    id: 2,
    image: kryptonite,
    title: "KRYPTONITE - Lock it. Trust it.",
    description:
      "Pametna i ozbiljna sigurnosna rješenja. U misiji inovacija s preko 50 godina sigurnosti bicikala. Ovdje da ti osnaži zaštitu onog što cijeniš. Idi gdje želiš, kada želiš.",
    description1: "",
    href: "./oprema/zastita/",
    button: "Kryptonite",
  },
  {
    id: 3,
    image: mucoff,
    title: "MUC-OFF - Clean ‧ Protect ‧ Lube",
    description:
      "Granice postoje samo za one koji ih prihvaćaju. Muc-Off čuva tvoj stroj besprijekornim dok ti napadaš staze. Oslobodi brutalne performanse bez ijednog kompromisa.",
    href: "/odrzavanje/sredstva-za-odrzavanje/",
    button: "Muc-Off",
  },
  {
    id: 4,
    image: odi,
    title: "ODI - Observe. Design. Innovate.",
    description:
      "Svjetski lider u tehnologiji gripova. Preko 40 godina posvećeni pružanju najboljeg što se može ponuditi u svakom proizvodu - opsežno istraženo i testirano od najboljih svjetskih vozača.",
    href: "/dijelovi/gripovi/",
    button: "ODI",
  },
]

export default slider
